<template>
	<div v-bind:class="{ 'with-view-all' : fileAttachmentsFullList.length > defaultNumberOfAttachmentsToDisplay }">
	    <v-list>
            <v-list-item class="text-hover-list" v-for="(item, i) in fileAttachments" :key="i" @click="displayAttachment(item)">
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="d-flex align-items-center overflow-hidden" style="gap:12px">
                        <v-icon class="attachment_icon p-0" v-if="item.extension === 'pdf'">mdi-file-pdf-box</v-icon>
                        <v-icon class="attachment_icon p-0" v-if="item.extension === 'doc' || item.extension === 'docx'">mdi-file-word</v-icon>
                        <v-icon class="attachment_icon p-0" v-if="item.extension !== 'doc' && item.extension !== 'docx' && item.extension !== 'pdf'">mdi-file</v-icon>
               
                        <v-list-item-content>
                            <v-list-item-title>
								<div v-if="item.name.length > 60" class="main-text-large overflow-hidden text-nowrap overflow-ellipsis" v-tooltip="item.name">
                                    {{ item.name.substring(0, 60) }} ...
                                </div>
								<div v-else class="main-text-large overflow-hidden text-nowrap overflow-ellipsis">
                                    {{ item.name }}
                                </div>
                            </v-list-item-title>
                              <v-list-item-subtitle>
                                <span v-if="item.createdBy && item.createdBy.length > 35" class="action-label-new overflow-hidden text-nowrap overflow-ellipsis" v-tooltip="item.createdBy">
                                    {{ $t("res_SubTitle_UploadedBy") + " " + item.createdBy.substring(0, 35) }} ...
                                </span>
								<span v-else class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                    {{ $t("res_SubTitle_UploadedBy") + " " + item.createdBy }}
                                </span>  
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <span  v-if="item.createdDate && item.createdDate.length > 32" class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                    {{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + item.createdDate.substring(0, 10) }}
                                </span>
                                <span  v-else class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                    {{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + item.createdDate.substring(0, 10) }}
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <v-chip dark label small v-if="i==0">
                                    {{ $t("res_Label_OriginalMail") }}
                                </v-chip>
                                <v-chip dark label small v-else>
                                    {{ $t("res_Label_Attachment") }}
                                </v-chip>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                <v-divider :thickness="10" v-if="i==0">
                                </v-divider> 
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </div>
                    <div class="d-flex align-items-center">
						<!-- hussein double check the condition of the configure signature button -->
						<div content-class="" v-if="i != 0 && item.extension === 'pdf' && item.signedBy == 0 && categoryId != 1" v-tooltip="ConfigureSignature">
							<div class="custom-icon-wrapper">
								<v-icon @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 4, i)">custom-icon white-bg pen-icon</v-icon>
							</div>
						</div>
                        <v-list-item-action-text>
                            <v-menu bottom offset-y content-class="" v-if="viewMode != 'readonly'" attach :left="!$vuetify.rtl" :right="$vuetify.rtl">
                            <!-- <v-menu content-class="align-top" left v-if="viewMode != 'readonly'"   attach > -->
                                <template v-slot:activator="{ on, attrs }" >
                                    <v-list-item v-bind="attrs" v-on="on" class="justify-content-between">
                                        <div class="custom-icon-wrapper">
											<v-icon>custom-icon white-bg vertical-dots-icon</v-icon>
										</div>
                                    </v-list-item>
                                </template>
                                <v-list class="list-actions">
                                    <v-list-item  v-if=" (item.extension === 'pdf' && item.signedBy==0)&&(categoryId != 1)" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 4, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Label_ConfigureSignatures") }}</v-list-item-title>
                                        </v-list-item-content>
                                </v-list-item>
                                 <v-list-item v-if="i!=0 && constants.signUsingDocusignEnabled" @click="signDocumentWithDocusign( item.storageAttachmentId)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Select_Docusign_Option") }}</v-list-item-title>
                                        </v-list-item-content>
                                </v-list-item>
                                 <v-list-item v-if="(i != 0 && item.isEditable) || categoryId == 1" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 1, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Label_Rename") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 2, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Label_Download") }} </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item  v-if ="i > 0" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 0, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_ButtonText_Delete") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="i > 0 && canDelete(i,item) && utils.ActionsPermission('Replace', document, transferId, delegationId , nodeId)" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 3, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_ButtonText_RescanByUpload") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="i==0 && isOutgoingByFile && utils.ActionsPermission('ReplaceOriginalMail', document, transferId, delegationId , nodeId)" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 3, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_ButtonText_RescanByUploadOriginal") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="i > 0 && canDelete(i,item) && utils.ActionsPermission('Replace', document, transferId, delegationId , nodeId)" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 5, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Label_ReplaceScan") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="i==0 && isOutgoingByFile && utils.ActionsPermission('ReplaceOriginalMailScan', document, transferId, delegationId , nodeId)" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 5, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Label_ReplaceScanOriginal") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <!-- <v-list-item v-if="i != 0 && item.extension === 'pdf' && item.signedBy==0" @click="openOptionPane(item.id, item.storageAttachmentId, item.name, item.extension, 4, i)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ $t("res_Label_ConfigureSignatures") }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item> -->
                                </v-list>
                            </v-menu>
						</v-list-item-action-text>
                        <span class="item-size dark-text text-end">
                            {{ utils.formatBytes(item.fileSize, 2)}}
                        </span>
                    </div>
                </div>
            </v-list-item>
        </v-list>

		<v-divider class="view-all-divider" v-if="fileAttachmentsFullList.length > defaultNumberOfAttachmentsToDisplay"></v-divider>

        <div class="view-all-wrapper d-flex justify-content-center align-content-center" v-if="fileAttachmentsFullList.length > defaultNumberOfAttachmentsToDisplay">
			<button class="view-all-btn d-flex align-items-center" @click="viewAllAttachments()" v-if="numberOfAttachmentsToDisplay != 1000">
				{{ $t("res_ButtonText_ViewAll") }} <v-icon class="light">mdi-chevron-down</v-icon>
			</button>
			<button class="view-all-btn d-flex align-items-center" @click="viewAllAttachments()" v-if="numberOfAttachmentsToDisplay == 1000">
				{{ $t("res_ButtonText_ShowLess") }} <v-icon class="light">mdi-chevron-up</v-icon>
			</button>
		</div>

        <!-- <label class="empty-list" v-if="fileAttachments.length === 0">
            {{ $t("res_Msgs_NoAttachment") }}
        </label> -->

        <v-dialog v-model="deleteAttachmentDialog" content-class="small-dialog" width="500" height="400">
            <v-card>
				<v-card-title>
                    {{ $t("res_Msgs_DeleteConfirmation") }}
                </v-card-title>
				<div class="card-body">
                    <label>{{ $t("res_Msgs_DeleteAttachmentConfirmation") }}</label>
				</div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="light-blue" @click="deleteAttachmentDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" @click="this.deleteAttachment">{{ $t("res_ButtonText_Continue") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="openScanDialog" content-class="dialog fullscreen-dialog bg-white" fullscreen>
            <v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">{{ $t('ResourceScanFile') }}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="openScanDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <ScanFile :documentId="documentId" @GetImageData="uploadScan"  ></ScanFile>
            </v-card>
        </v-dialog>

        <v-dialog v-model="renameAttachmentDialog" content-class="small-dialog" width="500" height="350">
            <v-card>
				<v-card-title>
                    {{ $t("res_GridHeaders_RenameAttachment") }}
                </v-card-title>
				<div class="card-body">
                    <label>{{ $t("res_Label_NewName") }}</label>
                    <v-text-field v-model="attachmentUpdatedName" solo></v-text-field>
                </div>
                <v-card-actions class="gap-2 sticky-actions">
                    <v-spacer></v-spacer>
                    <v-btn color="light-blue" @click="renameAttachmentDialog = false">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                    <v-btn color="primary" :disabled="isRenameButtonDisabled" @click="renameAttachment">{{ $t("res_ButtonText_Save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="attachmentConfigureDialog" content-class="dialog with-fixed-actions bg-white" width="100%" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <div class="d-flex align-items-center">
                        <v-icon class="back-btn"  @click="attachmentConfigureDialog = false">mdi-chevron-left</v-icon>
                        <h1 class="mb-0">{{ $t("res_Label_ConfigureSignatures") }}</h1>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="attachmentConfigureDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
            </div>
            <div class="dialog-body h-100">
                <iframe id="configureSignatureFrm" :src="configureSignatureSrc" style="width: 100%; height: 100%; min-height: 1000px;"></iframe>
            </div>
        </v-dialog> -->

        <v-dialog v-model="attachmentConfigureDialog" content-class="fullscreen-dialog dialog bg-white" width="100%" fullscreen>
            <div class="dialog-header">
                <v-toolbar class="bg-white">
                    <div class="d-flex align-items-center">
                        <div class="custom-icon-wrapper">
                            <v-icon @click="attachmentConfigureDialog = false">custom-icon left-arrow-icon</v-icon>
                        </div>
                        <h1 class="mb-0">{{ $t("res_Label_ConfigureSignatures") }}</h1>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex" style="gap:12px; margin-right:24px">
                        <!-- <v-btn icon width="24px" height="24px" style="min-width: unset !important"><v-icon class="custom-icon primary-hover">mdi-printer</v-icon></v-btn>
                        <v-btn icon width="24px" height="24px" style="min-width: unset !important"><v-icon class="custom-icon primary-hover">mdi-download</v-icon></v-btn> -->
                    </div>
                    <v-btn class="close-btn light-btn" icon dark @click="attachmentConfigureDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
            </div>
            <div class="dialog-body h-100 d-flex">
                <iframe id="configureSignatureFrm" :src="configureSignatureSrc" style="width: 100%; height: 100%;"></iframe>
            </div>
        </v-dialog>

        <input type="file" style="display:none" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.gif,.bmp,.tif,.tiff,.zip,.rar" @change="onMultiFileChanged" ref="multiUploader" multiple />
        <input type="file" style="display:none" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.gif,.bmp,.tif,.tiff,.zip,.rar" @change="onFileChanged" ref="uploader" multiple />
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import Multiselect  from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    import SignatureConfigure from '@/components/SignatureConfigure.vue'
    import ScanFile from '@/components/ScanFile.vue';


	export default {
        name: 'Attachment',
        components: { Multiselect, SignatureConfigure,ScanFile },
        props: {
            documentId: { type: Number, default: 0 },
            transferId: { type: Number, default: 0 },
            categoryId: { type: Number, default: 0 },
            documentSubject :{type:String,default:''},
            viewMode: { type: String, default: 'readonly' },
            nodeId: { type: Number, default: 0 },
            document: { type: Object, default: null },
            delegationId: { type: Number, default: 0 },
            isOutgoingByFile: { type: Boolean, default: false },
        },
        data() 
        {
            return {
                isOriginal:false,
                deleteAttachmentDialog: false,
                renameAttachmentDialog: false,
                fileAttachments: [],
                fileAttachmentsFullList: [],
                userId:0,
                document: {
                    firstAttachment: true,  
                    attachmentName: '',
                    originalAttachmentName: '',
                    attachmentId: 0, 
                    storageAttachmentId: 0,
                },
                attachmentUpdatedName: '',
                isRenameButtonDisabled: true,
                binaryAttachment: '',
                selectedFiles: [],
                selectedFile: {},
                constants:constants,
                attachSingleFile: false,
                attachMultipleFile: false,
                attachmentConfigureDialog: false,
                maxNumberOfSigners : 0,
                attachementHeading: '',
                attachmentId: 0,
                ConfigureSignature: window.translate("res_Label_ConfigureSignatures"),//"Configure Signature",
                configureSignatureSrc: '',
                icons: [
                    {icon: 'mdi-file-pdf-box', ext: 'pdf'},
                    {icon: 'mdi-file-document', ext: 'docx'},
                    {icon: 'mdi-file-document', ext: 'doc'},
                    {icon: 'mdi-file-image', ext: 'jpg'},
                    {icon: 'mdi-file-image', ext: 'jpeg'},
                    {icon: 'mdi-image', ext: 'png'},
                ],
                utils: utils,
                defaultNumberOfAttachmentsToDisplay: 3,
                numberOfAttachmentsToDisplay: 3,
                openScanDialog: false
            };
        },
        mounted() 
        {
            var user = JSON.parse(sessionStorage.getItem("user"));
            this.userId=user.profile.Id
            this.getAttachments()
        },
        watch: 
        {
            documentId()
            {
                this.getAttachments()
            },
            attachmentUpdatedName: function (newVal, oldVal)
            {
                if (this.attachmentUpdatedName.trim() == '' || this.attachmentUpdatedName == this.document.originalAttachmentName)
                    this.isRenameButtonDisabled = true
                else
                    this.isRenameButtonDisabled = false
            }
        },
        methods: 
        {
             signDocumentWithDocusign(attachmentId) 
             {
                window.showLoading();
                let baseUrl = constants.baseApiUrl;
                axios.post(baseUrl + 'Document/PrepareAttachmentForDocuSign?storageAttachmentId=' + attachmentId + "&documentId=" + this.documentId )
                    .then(res => 
                    {
                        var windowObjectReference = window.open(res.data.item2,"Sign With Docusign",'_blank');
                        window.hideLoading();
                    })
                    .catch(error => console.log(error))
            },
            canDelete(i,item)
            {
                if (constants.client_version_Id=="ADFD" || constants.client_version_Id=="UAEU")
                {
                    if ((i != 0 || (i==0 && this.categoryId == 1)) && item.isEditable && item.createdByUserId == this.userId &&  ( item.signedBy == 0 || item.transferId==this.transferId))
                        return true
                    else
                        return false
                }
                else
                {
                    if (i != 0 && item.isEditable && this.categoryId != 1 && item.createdByUserId == this.userId && item.signedBy == 0)
                        return true
                    else if (this.categoryId == 1 && item.isEditable && item.createdByUserId == this.userId && item.transferId == this.transferId)
                        return true
                    else
                        return false
                }
            },
         
            openOptionPane(attachmentId, storageAttachmentId, attachmentName, extension, optionId, attachmentKey)
            {
                this.document.attachmentId = attachmentId
                this.document.storageAttachmentId = storageAttachmentId
                this.document.attachmentName = attachmentName
                this.document.originalAttachmentName = attachmentName
                
                if (optionId == 1)
                {
                    this.attachmentUpdatedName = attachmentName
                    this.renameAttachmentDialog = true
                }
                else if (optionId == 2)
                {
                    var nameParts = attachmentName.split('.');
                    if (nameParts.length == 1)
                        this.downloadAttachment(attachmentId, attachmentName + '.' + extension)
                    else
                        this.downloadAttachment(attachmentId, attachmentName)
                }
                else if (optionId == 3)
                {
                    this.replaceAttachment(attachmentKey)
                }
                else if (optionId == 4)
                {
                    this.attachmentId = attachmentId
                    this.attachementHeading = attachmentName
                    this.maxNumberOfSigners = 0
                    var signatureCount = parseInt(window.documentView.template_signatureCount)

                    var url = "?signaturesCount=" + signatureCount + "&attachmentName=" + attachmentName + '&lang=' + this.$i18n.locale;

                    window.setConfigureSignatureData(this.documentId, this.attachmentId);
                    this.configureSignatureSrc = 'resources/configureSignature/ConfigureSignature.html'+url+'&r=' + new Date().getTime()
                    this.attachmentConfigureDialog = true
                }
                else if (optionId == 5)
                {
                    this.openScanDialog = true
                }
                else
                {   
                    this.deleteAttachmentDialog = true
                }
            },
            replaceAttachment(key)
            {
                if (key==0) 
                    this.isOriginal = true
                else 
                    this.isOriginal = false

                window.addEventListener('focus', () => {}, { once: true });
                this.attachSingleFile = true;
                this.$refs.uploader.click();
            },
            uploadScan(imageData)
            {
                var requestData = {
                    documentId: this.documentId,
                    name: this.document.attachmentName,
                    updateFileData: imageData,
                    storageAttachmentId: this.document.storageAttachmentId,
                    count: 0
                }

                const headers2 = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
                };

                window.showLoading();
                axios.post(constants.baseApiUrl + 'Document/UploadScan', requestData, { headers: headers2 })
                    .then((res) => {
                        if (res.data == true) 
                        {
                            window.showAlert("Updated Successfuly", "success")
                            this.getAttachments()
                            this.openScanDialog = false;
                        }
                        else
                        {
                            window.showAlert("Document Can't Be modified", "warning")
                        }
                    })
                    .catch(err => alert(err))
                    .finally(() => { window.hideLoading(); });
            },
            renameAttachment()
            {
                if (this.attachmentUpdatedName == '')
                {
                    window.showAlert('res_Msgs_EnterAttachmentName', 'warning')
                    return
                }

                this.renameAttachmentDialog = false

                window.showLoading()
                axios.get(constants.baseApiUrl + 'Attachment/UpdateAttachment?attachmentId=' + this.document.attachmentId + '&storageAttachmentId=' + this.document.storageAttachmentId + '&newName=' + this.attachmentUpdatedName)
                    .then(response => 
                    {
                        if (response.data.item1 == true)
                        {
                            this.getAttachments();
                            this.attachmentUpdatedName = ''
                            this.renameAttachmentDialog = false;

                            window.showAlert('res_Msgs_AttachmentRenamed', 'success')
                        }
                        else
                            alert(response.data.item2)
                    })
                    .catch(error => alert(error))
                    .finally(() => window.hideLoading())
            },
            deleteAttachment()
            {
                this.deleteAttachmentDialog = false
                this.fileAttachments = []
                this.fileAttachmentsFullList = []

                window.showLoading()
                axios.get(constants.baseApiUrl + 'Attachment/DeleteFile?id=' + this.document.attachmentId + "&documentId=" + this.documentId)
                    .then(response => 
                    { 
                        if (response.data != null)
                        {
                            this.getAttachments()
                            this.$refs.uploader.value = '';
                            this.$refs.multiUploader.value = '';
                            window.showAlert('res_Msgs_AttachmentDeleted', 'success')
                        }
                    })
                    .catch(error => alert(error))
                    .finally(() => window.hideLoading())
            },
            downloadAttachment(attachmentId, fileName)
            {
                utils.DownloadFile(constants.baseApiUrl + 'Attachment/Download?attachmentId=' + attachmentId, fileName)
            },
            getAttachments()
            {
                if (this.documentId == 0)
                    return
                
                this.fileAttachments = []
                this.fileAttachmentsFullList = []
                this.numberOfAttachmentsToDisplay = this.defaultNumberOfAttachmentsToDisplay
                
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Attachment/GetAttachmentsByDocumentId?documentId=' + this.documentId, {headers: constants.headers})
                    .then(response => 
                    {
                        if (response.data != null)
                        {  
                            this.firstAttachment = false
                            this.fileAttachments = []
                            this.fileAttachmentsFullList = []
                            response.data.forEach(element => 
                            {
                                if (this.fileAttachments.length < this.defaultNumberOfAttachmentsToDisplay)
                                    this.fileAttachments.push(element)
                                this.fileAttachmentsFullList.push(element)
                               
                            });

                            if (this.fileAttachments.length != 0)
                                this.$emit('setViewerUrl', this.fileAttachments[0].id);
                            else
                                this.$emit('setViewerUrl', 0);
                        }
                    })
                    .catch(error => alert(error))
                    .finally(() => window.hideLoading())
            },
            uploadAttachment()
            {
                if (this.firstAttachment)
                {
                    window.addEventListener('focus', () => {}, { once: true });
                    this.attachSingleFile = true;
                    this.$refs.uploader.click();
                }
                else
                {
                    window.addEventListener('focus', () => {}, { once: true });
                    this.attachMultipleFile = true;
                    this.$refs.multiUploader.click();
                }
                this.$refs.uploader.value = '';
                this.$refs.multiUploader.value = '';
            },
            onFileChanged(e) 
            {
                if(this.$refs.uploader.files[0].size <= 0 || this.$refs.uploader.files[0].size > parseInt(constants.maxAttachmentSizeInByte))
                {
                    window.showAlert(window.translate("res_Msgs_FileSizeValidation1") + constants.maxAttachmentSizeInMb +window.translate("res_Msgs_FileSizeValidation2"), "warning");
                }
                else
                {
                    this.uploadFile(this.$refs.uploader.files[0]);
                }
            },
            hasPermission(name) {
                return constants.userActions.features.some(f => f.name.toLowerCase() == name.toLowerCase());
            },
            uploadFile(selectedFile)
            {
                this.attachMultipleFile = false;
                this.attachSingleFile = false;

                if (this.document.storageAttachmentId > 0)
                {
                    let singleAttachment = new FormData();
                                    
                    singleAttachment.append('id', this.document.attachmentId)
                    singleAttachment.append('documentId', this.documentId)
                    singleAttachment.append('isOriginalMail', this.isOriginal)
                    if (this.transferId != 0)
                        singleAttachment.append('transferId', this.transferId)
                    singleAttachment.append('originalMail[0]', selectedFile)

                    const headers2 = {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')};

                    window.showLoading()
                    axios.post(constants.baseApiUrl +  'Attachment/Replace', singleAttachment, {headers: headers2})
                        .then(response => 
                        {
                            if (response != null && response != undefined)
                                this.getAttachments()
                        })
                        .catch(error => this.handleError(error))
                        .finally(() => window.hideLoading())
                }
                else
                {
                    let singleAttachment = new FormData();
                    singleAttachment.append('categoryId', this.categoryId)
                    singleAttachment.append('documentId', this.documentId)
                    if (this.transferId != 0)
                        singleAttachment.append('transferId', this.transferId)
                    singleAttachment.append('originalMail[0]', selectedFile)

                    const headers2 = {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
                    };

                    window.showLoading()
                    axios.post(constants.baseApiUrl + 'Attachment/UploadOriginalMail', singleAttachment, {headers: headers2})
                        .then(response => 
                        {
                            if(response != null || response != undefined)
                            {
                                this.getAttachments();
                            }
                        })
                        .catch(error => this.handleError(error))
                        .finally(() => window.hideLoading())
                }
            },
            onMultiFileChanged(e) 
            {
                Array.from(this.$refs.multiUploader.files).forEach(file => 
                {
                    if(file.size <= 0 || file.size > parseInt(constants.maxAttachmentSizeInByte) )
                    {
                        window.showAlert(window.translate("res_Msgs_FileSizeValidation1") + constants.maxAttachmentSizeInMb +window.translate("res_Msgs_FileSizeValidation2"), "warning");
                    }
                    else
                    {
                        this.uploadMultipleFiles(file);
                    }
                });
            },
            uploadMultipleFiles(selectedFiles)
            {
                this.attachMultipleFile = false;
                this.attachSingleFile = false;
                let attachments = new FormData();
                attachments.append('categoryId', this.categoryId)
                attachments.append('documentId', this.documentId)
                if (this.transferId != 0)
                    attachments.append('transferId', this.transferId)
                attachments.append('originalMail[0]', selectedFiles)

                const headers2 = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
                };

                window.showLoading();
                axios.post(constants.baseApiUrl + 'Attachment/Upload', attachments, {headers: headers2})
                    .then(response => 
                    {
                        if ((response != null || response != undefined) && response.data === "") 
                        {
                            this.getAttachments();
                            window.showAlert('res_Msgs_AttachmentUploaded', 'success');
                        } 
                        else 
                        {
                            window.showAlert(response.data, 'error');
                        }
                    })
                    .catch(error => this.handleError(error))
                    .finally(() => window.hideLoading());
            },
            displayAttachment(item)
            {
                this.$emit('setViewerUrl', item.id);
            },
            viewAllAttachments()
            {
                if (this.numberOfAttachmentsToDisplay == 1000)
                {
                    this.numberOfAttachmentsToDisplay = this.defaultNumberOfAttachmentsToDisplay
                    this.fileAttachments = this.fileAttachmentsFullList.slice(0, this.defaultNumberOfAttachmentsToDisplay)
                }
                else
                {
                    this.numberOfAttachmentsToDisplay = 1000
                    this.fileAttachments = this.fileAttachmentsFullList
                }
            }
        },
    }

    import 'floating-vue/dist/style.css'
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .attachment_icon { font-size: 30px; padding-left: 5px; padding-right: 5px; color: cornflowerblue; }
</style>